export default __webpack_public_path__ + "static/media/focusImg.28968e31.jpg";